export function openDatabase(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open("onggoing_db", 1);

        request.onupgradeneeded = (e: IDBVersionChangeEvent) => {
            const db = (e.target as IDBOpenDBRequest).result;
            if (!db.objectStoreNames.contains('data')) {
                db.createObjectStore('data', {keyPath: 'id'});
            }
        };

        request.onerror = (e: Event) => {
            reject(`Database error: ${(e.target as IDBOpenDBRequest).error?.name}`);
        };

        request.onsuccess = (e: Event) => {
            resolve((e.target as IDBOpenDBRequest).result);
        };
    });
}

export async function setIndexedDBItem(key: string, data: any): Promise<string> {
    const db = await openDatabase();
    const transaction = db.transaction(['data'], 'readwrite');
    const store = transaction.objectStore('data');

    return new Promise((resolve, reject) => {
        const request = store.put({id: key, value: data});
        request.onsuccess = () => {
            resolve('Data saved successfully.');
        };
        request.onerror = (e: Event) => {
            reject(`Error saving data: ${(e.target as IDBRequest).error?.name}`);
        };
    });
}

export async function getIndexedDBItem(key: string): Promise<any | null> {
    const db = await openDatabase();
    const transaction = db.transaction(['data'], 'readonly');
    const store = transaction.objectStore('data');

    return new Promise((resolve, reject) => {
        const request = store.get(key);
        request.onsuccess = () => {
            resolve(request.result ? request.result.value : null);
        };
        request.onerror = (e: Event) => {
            reject(`Error fetching data: ${(e.target as IDBRequest).error?.name}`);
        };
    });
}
